export default function AtcFlightsCarouselBaseController(
    $scope,
    $rootScope,
    $q,
    atcFlightsFactory,
    atcFlightsService,
    baseEvents,
    atcFlightFareService,
    l10nService,
) {
    'ngInject';
            const FILTER_BY_AIRLINE_TITLE = l10nService.localize('Show this flight and all flights for');
            $scope.flightFareService = atcFlightFareService;
            $scope.l10nService = l10nService;
            $scope.getFlightSupplierLogoSmall = atcFlightsService.getFlightSupplierLogoSmall;
            $q.when(atcFlightsFactory.getFlights()).then(function(flights) {
                $scope.matrix = flights;
            });

            $scope.sortComparison = function(comparisonFilter, airline, isDirect) {
                atcFlightsFactory.resetSegmentFilterData();
                $rootScope.$broadcast(baseEvents.CLEAR_SEGMENTS);
                $rootScope.$broadcast(baseEvents.COMPARISON_FILTER, {airline, comparisonFilter, isDirect});
            };

            $scope.filterByAirline = function(airline) {
                const hash = `${airline}${Math.random()}`;
                $scope.sortComparison(hash, airline);
            };
            $scope.getTitle = function(airlineName) {
                return `${FILTER_BY_AIRLINE_TITLE} ${airlineName}`;
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcFlightsCarouselBaseController.js